import React, { useEffect } from "react";
import 'date-fns';
import { format, } from 'date-fns';
import {
  Typography,
  Grid,
  Paper,
} from "@material-ui/core";
import QAListFormCR from '../component/portal/qalist/customer/QAListForm'
import QAListFormEE from '../component/portal/qalist/employee/QAListForm'
import QAListResult from '../component/QAListResult'
import PickerToolbar from "@material-ui/pickers/_shared/PickerToolbar";
import ToolbarButton from "@material-ui/pickers/_shared/ToolbarButton";
import * as wijmo from "@grapecity/wijmo";
import { getCustomerList, getQAList, typeCustomerList } from "../api/helpline/qa"
import { getAllContractList, getCisUserList, getContractItemList, typeCisUserList, typeContractItemList, typeContractList } from '../api/helpline/keiyaku'
import { getCategory, typeCategory } from '../api/helpline/master'
import { useDispatch, useGlobalState } from "../provider/Provider";
import { cisUser, getSessionStorageForm, isSessionStorageForm, removeSessionStorage, removeSessionStorageForm } from "../User";
import { getUserInfo } from "../api/helpline/user";

interface Form {
  userId: string,
  qano: string,
  qastatus: string[],
  keyword: string,
  keiyakuno: string,
  keiyakuClsCd: string,
  qaSeCd: string,
}


interface Props {
  handleClickQAno: (num: string) => void,
  handleListHistory: () => void,
  handleError: (err: any) => void,
}

const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!

const QAList: React.FC<Props> = (props) => {
  const globalState = useGlobalState('user')
  const globalbpState = useGlobalState('page')
  const globalqalistState = useGlobalState('qalist')
  const globalconlistState = useGlobalState('contractlist')
  const dispatch = useDispatch()
  const { userId, token, role } = globalState
  const { handleClickQAno, handleListHistory, handleError } = props
  //契約項目取得
  const [contractItemList, setContractItemList] = React.useState<typeContractItemList[] | undefined>()
  //契約項目全取得
  const [contractList, setContractList] = React.useState<typeContractList[] | undefined>()

  //分類項目取得(qastatus)
  const [qastatus, setQastatus] = React.useState<typeCategory[]>([])
  const [qastatusName, setQastatuName] = React.useState<string[]>([])
  const [loading, setLoading] = React.useState<boolean>(false)
  const [sesloading, setSesloading] = React.useState<boolean>(false)
  //顧客情報
  const [customerList, setCustomerList] = React.useState<typeCustomerList[]>([])
  //CIS社員情報
  const [cisUserList, setCisUserList] = React.useState<typeCisUserList[]>([])
  const tableTitle: string = ''
  const pageSize: number = 20
  const [form, setForm] = React.useState<Form>({
    userId: role === rolecustomer ? userId : '',
    qano: '',
    qastatus: [],
    keyword: '',
    keiyakuno: '',
    keiyakuClsCd: '',
    qaSeCd: ''
  })
  const [startdate, setStartDate] = React.useState<Date | null>(null)
  const [enddate, setEndDate] = React.useState<Date | null>(null)
  const [loginUser, setLoginUser] = React.useState(false)

  const _onInitialized = (sender: any) => {
    sender.calendar.formatItem.addHandler((sender: any, e: any) => {
      let weekday = e.data.getDay();
      wijmo.toggleClass(e.item, "date-sunday", weekday === 0);
      wijmo.toggleClass(e.item, "date-saturday", weekday === 6);
    })
  }
  const _onValueChanged = (sender: { value: Date, inputElement: HTMLInputElement }) => {
    if (sender.inputElement.name === 'startdate') {
      setStartDate(sender.value)
    } else if (sender.inputElement.name === 'enddate') {
      setEndDate(sender.value)
    }
  }

  const chipDelete = (i: number) => {
    if (form.qastatus && qastatusName) {
      setForm({
        ...form,
        "qastatus": form.qastatus.filter((value, index) => index !== i),
      })
      setQastatuName(qastatusName.filter((value, index) => index !== i))
    }
  }

  const PickerToolBar = (props: any) => {
    const { date, isLandscape, openView, setOpenView, title } = props;
    const handleChangeViewClick = (view: string) => (e: any) => {
      setOpenView(view);
    };
    return (
      <PickerToolbar
        title={title}
        isLandscape={isLandscape}
      >
        <ToolbarButton
          onClick={handleChangeViewClick("month")}
          variant="h6"
          label={format(date, 'yyyy') + "年" + format(date, "MM") + "月"}
          selected={openView === "month"}
        />
      </PickerToolbar>
    );
  };

  //文字数カット
  const MAX_LENGTH_Keyword = 128
  const checkCutLength = (str: string, name: string) => {
    if (name === 'keyword') {
      if (str.length > MAX_LENGTH_Keyword) {
        return str.substr(0, MAX_LENGTH_Keyword)
      } else {
        return str
      }
    } else {
      return str
    }
  }


  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    if (event.target.name === "qastatus") {
      let pushlist: string[] = []
      let cdList = event.target.value as string[]
      cdList.map(value => {
        qastatus.map(val => {
          if (value === val.categoryCd) {
            pushlist.push(val.categoryName)
          }
        })
      })
      setQastatuName(pushlist)
    }
    setForm({
      ...form,
      [event.target.name as string]: checkCutLength(event.target.value as string, event.target.name as string)
    })
  }

  const handleChangeCompanyCd = (companyObj: typeCustomerList | null) => {
    if (companyObj) {
      setForm({
        ...form,
        userId: companyObj.departmentCd
      })
    } else {
      setForm({
        ...form,
        userId: ''
      })
    }
  }
  const handleChangeKeiyakuCd = (keiyakuObj: typeContractList | null) => {
    if (keiyakuObj) {
      setForm({
        ...form,
        keiyakuClsCd: keiyakuObj.keiyakuClsCd
      })
    } else {
      setForm({
        ...form,
        keiyakuClsCd: ''
      })
    }
  }

  const handleChangeSeCd = (seObj: typeCisUserList | null) => {
    if (seObj) {
      setForm({
        ...form,
        qaSeCd: seObj.userCd
      })
    } else {
      setForm({
        ...form,
        qaSeCd: ''
      })
    }
  }

  const handleSetLoginUserCd = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginUser(event.target.checked)
  }

  const setSessionform = (form: Form) => {
    removeSessionStorageForm()
    form['startdate'] = startdate
    form['enddate'] = enddate
    const setstr = unescape(encodeURIComponent(JSON.stringify(form)))
    sessionStorage.setItem('SESSIONFORM', btoa(setstr));
  }

  //初期表示APIコール
  useEffect(() => {
    let cleanup = false//コンポーネントが破棄された場合に更新処理を止める
    if (userId && token) {
      setSesloading(true)
      if (role === rolecustomer) {//顧客
        //契約項目取得
        getContractItemList(userId, userId, token, role).then(res => { if (!cleanup) { setContractItemList(res) } }).catch(err => handleError(err))
        //分類項目取得(qastatus)
        getCategory('qastatus', userId, token, role).then(res => {
          if (!cleanup) {
            setQastatus(res.filter(value => value.categoryCd !== 'd'))
            if (globalqalistState.length !== 0 && isSessionStorageForm() && globalbpState.backpage) {//storageのformをセット
              const [resform] = getSessionStorageForm()
              setForm({
                ...form,
                userId: resform.userId,
                qano: resform.qano,
                qastatus: resform.qastatus,
                keyword: resform.keyword,
                keiyakuno: resform.keiyakuno,
              })
              setStartDate(resform.startdate ? new Date(resform.startdate) : null)
              setEndDate(resform.enddate ? new Date(resform.enddate) : null)
              setQastatuName(resform.qastatus.map((value: string) => res.filter(resvalue => {
                if (value === resvalue.categoryCd) {
                  return resvalue.categoryCd
                }
              })).flat().map((value: { categoryName: string; }) => value.categoryName))
              dispatch({//復元
                type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: globalqalistState, contractlist: globalconlistState
              })
              dispatch({//backpage 初期化
                type: 'SET_PAGE', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: globalconlistState
              })
              setSesloading(false)
            } else {
              dispatch({ type: 'SET_QALIST', payload: globalState, page: { backpage: false }, qalist: [], contractlist: globalconlistState })//QAListResults初期化
              setForm({ ...form, "qastatus": res.filter(value => value.categoryCd !== 'd').map(value => value.categoryCd) })
              setQastatuName(res.filter(value => value.categoryCd !== 'd').map(value => value.categoryName))
              setSesloading(false)
            }
          }
        }).catch(err => handleError(err))

      } else {//社員
        //顧客情報全取得
        getCustomerList(userId, token, role, '').then(res => { if (!cleanup) { setCustomerList(res) } }).catch(err => handleError(err))
        //契約項目全取得
        getAllContractList(userId, token, role).then(res => { if (!cleanup) { setContractList(res) } }).catch(err => handleError(err))
        //CIS社員情報
        getCisUserList(userId, token, role, '').then(res => { if (!cleanup) { setCisUserList(res) } }).catch(err => handleError(err))
        //分類項目取得(qastatus)
        getCategory('qastatus', userId, token, role).then(res => {
          if (!cleanup) {
            setQastatus(res)
            if (globalqalistState.length !== 0 && isSessionStorageForm() && globalbpState.backpage) {//storageのformをセット
              const [resform] = getSessionStorageForm()
              setForm({
                ...form,
                userId: resform.userId,
                qano: resform.qano,
                qastatus: resform.qastatus,
                keyword: resform.keyword,
                keiyakuno: resform.keiyakuno,
                keiyakuClsCd: resform.keiyakuClsCd,
                qaSeCd: resform.qaSeCd,
              })
              setStartDate(resform.startdate ? new Date(resform.startdate) : null)
              setEndDate(resform.enddate ? new Date(resform.enddate) : null)
              setQastatuName(resform.qastatus.map((value: string) => res.filter(resvalue => {
                if (value === resvalue.categoryCd) {
                  return resvalue.categoryCd
                }
              })).flat().map((value: { categoryName: string; }) => value.categoryName))
              dispatch({//復元
                type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: globalqalistState, contractlist: globalconlistState
              })
              dispatch({//backpage 初期化
                type: 'SET_PAGE', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: globalconlistState
              })
              setSesloading(false)
            } else {
              dispatch({ type: 'SET_QALIST', payload: globalState, page: { backpage: false }, qalist: [], contractlist: globalconlistState })//QAListResults初期化
              setForm({ ...form, "qastatus": res.map(value => value.categoryCd) })
              setQastatuName(res.map(value => value.categoryName))
              setSesloading(false)
            }
          }
        }).catch(err => handleError(err))
      }
    }
  }, [userId, token])

  const onSubmit = async () => {
    setLoading(true)
    if (globalbpState.backpage) {
      dispatch({ type: 'SET_PAGE', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: globalconlistState })
    }
    handleListHistory()
    removeSessionStorage()//remove QAResult session
    if (loginUser) {
      getUserInfo(userId, userId, token, role).then(res => {//ログインユーザーSEcd取得
        let sesObj = Object.assign({}, form)
        sesObj["qaSeCd"] = res.userCd
        setSessionform(sesObj)//set QAListForm
        getQAList(form.userId, userId, token, role, form.qano.replace(/_/g, ''), form.keiyakuno, form.qastatus.join(','), startdate, enddate, form.keyword, form.keiyakuClsCd, res.userCd).then(res => {
          dispatch({
            type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: res, contractlist: globalconlistState
          })
          setLoading(false)
        }).catch(err => { setLoading(false); handleError(err) })
      }).catch(err => { handleError(err) })
    } else {
      setSessionform(form)//set QAListForm
      getQAList(form.userId, userId, token, role, form.qano.replace(/_/g, ''), form.keiyakuno, form.qastatus.join(','), startdate, enddate, form.keyword, form.keiyakuClsCd, form.qaSeCd).then(res => {
        dispatch({
          type: 'SET_QALIST', payload: globalState, page: globalbpState, qalist: res, contractlist: globalconlistState
        })
        setLoading(false)
      }).catch(err => { setLoading(false); handleError(err) })
    }
  }

  return (
    <React.Fragment>
      <Typography variant="h6" style={{ flexGrow: 1 }}>
        Q&A一覧
      </Typography>
      <Grid container spacing={1} justify="center" >
        <Grid item xs={12}>
          <Paper>
            {role === rolecustomer &&
              <QAListFormCR form={form} qastatusName={qastatusName} PickerToolBar={PickerToolBar} chipDelete={chipDelete} handleChangeForm={handleChangeForm} onSubmit={onSubmit} contractItemList={contractItemList} qastatus={qastatus} loading={loading} _onInitialized={_onInitialized} _onValueChanged={_onValueChanged} startdate={startdate} enddate={enddate} />
            }
            {cisUser(role) &&
              <QAListFormEE form={form} qastatusName={qastatusName} PickerToolBar={PickerToolBar} chipDelete={chipDelete} handleChangeForm={handleChangeForm} onSubmit={onSubmit} contractList={contractList} qastatus={qastatus} loading={loading} _onInitialized={_onInitialized} _onValueChanged={_onValueChanged} startdate={startdate} enddate={enddate} customerList={customerList} handleChangeCompanyCd={handleChangeCompanyCd} handleChangeKeiyakuCd={handleChangeKeiyakuCd} cisUserList={cisUserList} loginUser={loginUser} handleSetLoginUserCd={handleSetLoginUserCd} handleChangeSeCd={handleChangeSeCd} />
            }
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <QAListResult
              handleClickQAno={handleClickQAno}
              tableTitle={tableTitle}
              pageSize={pageSize}
              loading={sesloading}
            />
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
export default QAList;